import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { CalendarDays, Clock, CheckCircle2, Layers } from "lucide-react";

const styles = {
  card: { border: "1px solid #E5E7EB", borderRadius: 12 },
  icon: {
    width: 44,
    height: 44,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  label: { fontSize: 12.5, color: "#6B7280", marginBottom: 3 },
  value: { fontSize: 19, fontWeight: 700, color: "#111827" },
};

const StatCard = ({ icon, label, value, bg, color }) => (
  <Col md={3}>
    <Card className="h-100" style={styles.card}>
      <Card.Body className="d-flex align-items-center gap-3">
        <div style={{ ...styles.icon, background: bg, color }}>{icon}</div>
        <div>
          <div style={styles.label}>{label}</div>
          <div style={styles.value}>{value}</div>
        </div>
      </Card.Body>
    </Card>
  </Col>
);

const ReportStatsCards = ({ stats, reported }) => (
  <Row className="mb-3 gy-3">
    <StatCard
      icon={<CalendarDays size={20} />}
      label={reported ? "Reported Days" : "Working Days"}
      value={stats.workingDays}
      bg="#DBEAFE"
      color="#2563EB"
    />
    <StatCard
      icon={<Clock size={20} />}
      label="Total Hours"
      value={`${stats.totalHours} Hrs`}
      bg="#DBEAFE"
      color="#2563EB"
    />
    <StatCard
      icon={<CheckCircle2 size={20} />}
      label="Tasks Completed"
      value={stats.tasksCompleted}
      bg="#DCFCE7"
      color="#16A34A"
    />
    <StatCard
      icon={<Layers size={20} />}
      label="Modules Worked On"
      value={stats.modulesWorkedOn}
      bg="#FEF3C7"
      color="#D97706"
    />
  </Row>
);

export default ReportStatsCards;

